export default {
    manager: {
        name:  '',
        phone: '',
    },
    popup: {
        isShow:        false,
        refillComplex: '',
    },
};
